import React, { useEffect, useRef, useState } from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { PATH_DASHBOARD } from 'src/routes/paths'
import { Backdrop, Box, Fab, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse } from '@mui/material'
import useStore from 'src/contexts/AuthProvider'
import WidgetsIcon from "@mui/icons-material/Widgets"
import GridViewIcon from '@mui/icons-material/GridView'
import PersonIcon from '@mui/icons-material/Person'
import BusinessIcon from '@mui/icons-material/Business'
import AppsIcon from '@mui/icons-material/Apps'
import StarIcon from '@mui/icons-material/Star'
import ChatBubbleIcon from '@mui/icons-material/ChatBubble'
import HelpIcon from '@mui/icons-material/Help'
import SettingsIcon from '@mui/icons-material/Settings'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import LinkIcon from '@mui/icons-material/Link'
import HistoryIcon from '@mui/icons-material/History'
import PostAddIcon from '@mui/icons-material/PostAdd'
import EventIcon from '@mui/icons-material/Event'
import GroupIcon from '@mui/icons-material/Group'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import CampaignIcon from '@mui/icons-material/Campaign'
import TuneIcon from '@mui/icons-material/Tune'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import UpdateIcon from '@mui/icons-material/Update'
import ReportIcon from '@mui/icons-material/Report'
import ContactPageIcon from '@mui/icons-material/ContactPage'
import NotificationsIcon from '@mui/icons-material/Notifications'
import PolicyIcon from '@mui/icons-material/Policy'
import GradingIcon from '@mui/icons-material/Grading'
import SecurityIcon from '@mui/icons-material/Security'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import CategoryIcon from '@mui/icons-material/Category'
import PublicIcon from '@mui/icons-material/Public'

// Hierarchical sidebar data structure matching the new UI design
const sidebarData = [
    {
        linkText: 'dashboard',
        link: PATH_DASHBOARD.general.dashboard,
        icon: <GridViewIcon />,
        permission: "",
    },
    {
        linkText: 'user profiles',
        icon: <PersonIcon />,
        permission: "users",
        children: [
            {
                linkText: 'deactivated accounts',
                link: PATH_DASHBOARD.general.users,
                permission: "users",
            },
            {
                linkText: 'deleted accounts',
                link: PATH_DASHBOARD.general.userDeleteReq,
                permission: "users",
            },
            {
                linkText: 'restore users',
                link: PATH_DASHBOARD.general.restoreDeletedReq,
                permission: "users",
            },
        ]
    },
    {
        linkText: 'business profiles',
        icon: <BusinessIcon />,
        permission: "business_request",
        children: [
            {
                linkText: 'team members request',
                link: PATH_DASHBOARD.general.teamMemberLinking,
                permission: "business_request",
            },
            {
                linkText: 'deactivated accounts',
                link: PATH_DASHBOARD.general.business,
                permission: "business_request",
            },
            {
                linkText: 'deleted accounts',
                link: PATH_DASHBOARD.general.userDeleteReq,
                permission: "business_request",
            },
            {
                linkText: 'restore businesses',
                link: PATH_DASHBOARD.general.restoreDeletedReq,
                permission: "business_request",
            },
        ]
    },
    {
        linkText: 'app modules',
        icon: <AppsIcon />,
        permission: "",
        children: [
            {
                linkText: 'track and trace',
                icon: <LinkIcon />,
                children: [
                    {
                        linkText: 'requests',
                        link: PATH_DASHBOARD.general.traceRequest,
                        permission: "trace_request",
                    },
                    {
                        linkText: 'history',
                        link: PATH_DASHBOARD.general.traceHistory,
                        permission: "trace_history",
                    },
                ]
            },
            // {
            //     linkText: 'employee',
            //     icon: <PersonIcon />,
            //     children: [
            //         {
            //             linkText: 'employee request',
            //             link: PATH_DASHBOARD.general.employeeRequest,
            //             permission: "employee_request",
            //         },
            //         {
            //             linkText: 'employee history',
            //             link: PATH_DASHBOARD.general.employeeRequestHistory,
            //             permission: "employee_history",
            //         },
            //     ]
            // },
            {
                linkText: 'posts',
                link: PATH_DASHBOARD.general.postList,
                permission: "posts",
            },
            {
                linkText: 'events',
                link: PATH_DASHBOARD.general.event,
                permission: "event",
            },
            {
                linkText: 'event category',
                link: PATH_DASHBOARD.general.eventCategory,
                permission: "event",
            },
            {
                linkText: 'chat',
                link: PATH_DASHBOARD.general.chatGroup,
                permission: "users",
            },
            {
                linkText: 'beemr',
                // link: PATH_DASHBOARD.general.business,
                permission: "",
                comingSoon: true,
            },
            {
                linkText: 'fast marketing',
                link: PATH_DASHBOARD.general.fastmarketingList,
                permission: "",
            },
            {
                linkText: 'app module configuration',
                link: PATH_DASHBOARD.general.configurableFields,
                permission: "configurable_fields",
            },
        ]
    },
    {
        linkText: 'trust level',
        icon: <StarIcon />,
        permission: "trust_level",
        children: [
            {
                linkText: 'trust level settings',
                link: PATH_DASHBOARD.general.trustLevel,
                permission: "trust_level",
            },
            {
                linkText: 'failed id entry attempts',
                link: PATH_DASHBOARD.general.idVerifyLimit,
                permission: "users",
            },
            {
                linkText: 'update id verification',
                link: PATH_DASHBOARD.general.updateIdVerification,
                permission: "users",
            },
        ]
    },
    {
        linkText: 'business chat configuration',
        icon: <ChatBubbleIcon />,
        permission: "",
        children: [
            {
                linkText: 'business category',
                link: PATH_DASHBOARD.general.categorys,
                permission: "category",
            },
            {
                linkText: 'business sub category',
                link: PATH_DASHBOARD.general.businessSubCategory,
                permission: "category",
            },
            {
                linkText: 'chat categories',
                link: PATH_DASHBOARD.general.chatCategorys,
                permission: "chat_category",
            },
        ]
    },
    {
        linkText: 'user support',
        icon: <HelpIcon />,
        permission: "",
        children: [
            {
                linkText: 'report subjects',
                link: PATH_DASHBOARD.general.reportSubject,
                permission: "",
            },
            {
                linkText: 'reports',
                link: PATH_DASHBOARD.general.report,
                permission: "",
            },
            {
                linkText: 'contact us',
                link: PATH_DASHBOARD.general.contactUs,
                permission: "",
            },
            {
                linkText: 'bulk notifications',
                link: PATH_DASHBOARD.general.bulkNotification,
                permission: "",
            },
            {
                linkText: 'user terms and conditions',
                link: PATH_DASHBOARD.general.termsCondition,
                permission: "",
            },
            {
                linkText: 'privacy policy',
                link: PATH_DASHBOARD.general.privacyPolicy,
                permission: "",
            },
            {
                linkText: 'child support policy',
                link: PATH_DASHBOARD.general.businessChildPolicyView,
                permission: "",
            },
            {
                linkText: 'subscription terms and conditions',
                link: PATH_DASHBOARD.general.subscriptionAgreement,
                permission: "",
            },
        ]
    },
    {
        linkText: 'general settings',
        icon: <SettingsIcon />,
        permission: "",
        children: [
            {
                linkText: 'your profile',
                link: PATH_DASHBOARD.general.profileSetting,
                permission: "",
            },
            {
                linkText: 'roles/permissions',
                link: PATH_DASHBOARD.general.rolesPermissions,
                permission: "roles",
            },
            {
                linkText: 'sub admins',
                link: PATH_DASHBOARD.general.admin,
                permission: "sub_admin",
            },
            {
                linkText: 'business roles/permissions',
                link: PATH_DASHBOARD.general.businessRolesPermission,
                permission: "business_request",
            },
        ]
    },
    // {
    //     linkText: 'country region',
    //     link: PATH_DASHBOARD.general.countryRegion,
    //     icon: <PublicIcon />,
    //     permission: "",
    // },
    // {
    //     linkText: 'settings',
    //     link: PATH_DASHBOARD.general.settings,
    //     icon: <SettingsIcon />,
    //     permission: "",
    // },
]

// Recursive component for nested menu items
const SidebarMenuItem = ({ item, level = 0, onNavigate }) => {
    const location = useLocation()
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const activeLink = location.pathname

    const handleToggle = () => {
        setOpen(!open)
    }

    const handleNavigation = (link) => {
        if (link && !item.comingSoon) {
            navigate(link)
            onNavigate()
        }
    }

    const hasChildren = item.children && item.children.length > 0
    const isActive = item.link && activeLink === item.link

    return (
        <>
            <ListItem 
                sx={{
                    "&.MuiListItem-root": {
                        padding: "0",
                        paddingLeft: `${level * 20}px`,
                    }
                }}
            >
                <ListItemButton 
                    onClick={() => hasChildren ? handleToggle() : handleNavigation(item.link)}
                    className={`sidebar_item_new ${isActive ? "isActive" : ""}`}
                    disabled={item.comingSoon}
                    sx={{
                        "&.MuiButtonBase-root": {
                            padding: "10px 20px",
                            minHeight: "44px",
                            cursor: item.comingSoon ? "not-allowed" : "pointer",
                        },
                        "&.Mui-disabled": {
                            opacity: 0.7,
                        },
                    }}
                >
                    {item.icon && (
                        <ListItemIcon 
                            sx={{
                                "&.MuiListItemIcon-root": {
                                    minWidth: "35px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    color: isActive ? "#6200ee" : "#5f6368",
                                }
                            }}
                        >
                            {item.icon}
                        </ListItemIcon>
                    )}
                    <ListItemText 
                        primary={item.comingSoon ? `${item.linkText} (coming soon)` : item.linkText}
                        sx={{
                            "& .MuiListItemText-primary": {
                                fontSize: "14px",
                                fontWeight: isActive ? 600 : 400,
                                color: item.comingSoon ? "#9e9e9e" : (isActive ? "#6200ee" : "#5f6368"),
                                textTransform: "lowercase",
                                fontFamily: "'Google Sans', Roboto, Arial, sans-serif",
                            }
                        }}
                    />
                    {hasChildren && (
                        <ListItemIcon 
                            sx={{
                                "&.MuiListItemIcon-root": {
                                    minWidth: "24px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#5f6368",
                                }
                            }}
                        >
                            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </ListItemIcon>
                    )}
                </ListItemButton>
            </ListItem>
            {hasChildren && (
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {item.children.map((child, index) => (
                            <SidebarMenuItem 
                                key={index} 
                                item={child} 
                                level={level + 1}
                                onNavigate={onNavigate}
                            />
                        ))}
                    </List>
                </Collapse>
            )}
        </>
    )
}

const MainSidebarNew = () => {
    const location = useLocation()
    let activeLink = location.pathname
    const permissionsData = useStore(state => state.permissions)
    const sidebarContentBoxRef = useRef(null)
    const [showDashboard, setShowDashboard] = useState(false)
    const [isOpenedManually, setIsOpenedManually] = useState(false)

    const handleLinkOnClick = () => {
        setShowDashboard(false)
        setIsOpenedManually(false)
    }

    useEffect(() => {
        sidebarContentBoxRef?.current?.addEventListener("scroll", () => {
            if (sidebarContentBoxRef.current.scrollTop > 10) {
                sidebarContentBoxRef.current.classList.add("scrolling")
            } else {
                sidebarContentBoxRef.current.classList.remove("scrolling")
            }
        })
    }, [])

    useEffect(() => {
        const handleResize = () => {
            const windowCurrentWidth = window.outerWidth
            if (windowCurrentWidth < 991 && activeLink.includes("/dashboard")) {
                setShowDashboard(false)
                setIsOpenedManually(false)
            }
        }
        
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [activeLink])

    const handleSidebarOnManualOpen = () => {
        setIsOpenedManually(true)
        setShowDashboard(true)
    }

    const handleDashboardBackdropClose = () => {
        setShowDashboard(false)
        setIsOpenedManually(false)
    }

    return (
        <>
            <div className={`main_sidebar_wrapper_new ${showDashboard ? "show" : ""}`}>
                {(activeLink.includes('/dashboard/') || activeLink === '/') &&
                    <List className='sidebar_list_new' sx={{ padding: 0 }}>
                        {sidebarData.map((item, index) => (
                            <SidebarMenuItem 
                                key={index} 
                                item={item} 
                                level={0}
                                onNavigate={handleLinkOnClick}
                            />
                        ))}
                    </List>
                }
            </div>
            
            {isOpenedManually && (
                <Backdrop
                    className="dashbord_backdrop"
                    sx={{ color: "#fff" }}
                    open={isOpenedManually}
                    onClick={handleDashboardBackdropClose}
                />
            )}

            {!showDashboard && (
                <Fab
                    aria-label="add"
                    className="dashboard_sidebar_button"
                    onClick={handleSidebarOnManualOpen}
                >
                    <WidgetsIcon className="sidebar_opan_icon" />
                </Fab>
            )}
        </>
    )
}

export default MainSidebarNew
